var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "div",
        {
          staticClass:
            "css-grid pay-invoice-form__row pay-invoice-form__row--header pay-invoice-form__row--error"
        },
        [
          _c("div"),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "pay-invoice-view__cell pay-invoice-view__cell--header"
            },
            [_vm._v("Payment Gateway Down")]
          ),
          _vm._v(" "),
          _c("div")
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "panel" }, [
        _c("div", { staticClass: "css-grid pay-invoice-form__row" }, [
          _c("div"),
          _vm._v(" "),
          _c("div", { staticClass: "pay-invoice__message h-center-align" }, [
            _vm._v(
              "\n        The payment processing gateway is undergoing maintenance. Please contact the accounting department at accounting@fuelmedical.com to process your payment.\n        "
            ),
            _c("br"),
            _c("br"),
            _vm._v(
              "\n        Apologies for any inconvenience this has caused. We're working diligently to resolve the matter.\n      "
            )
          ]),
          _vm._v(" "),
          _c("div")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }